export default __webpack_public_path__ + "static/media/shape-2.df43ce9c.png";